var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachments({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1244 -582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.156,8.718l-8.375,8.4a4.167,4.167,0,0,1-5.893-5.894L12.745,2.4a2.5,2.5,0,1,1,3.536,3.535L9.191,12.988A.833.833,0,0,1,8.013,11.81l5.911-5.875L12.745,4.756,6.834,10.631a2.5,2.5,0,1,0,3.535,3.537l7.089-7.054a4.167,4.167,0,1,0-5.894-5.892l-8.856,8.82a5.834,5.834,0,0,0,8.25,8.251l8.375-8.4L18.156,8.718Z",
    transform: "translate(1244.181 581.999)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachments);
export default __webpack_public_path__ + "static/media/attachments.7e375772cf492ff5e4ac2643581c7a32.svg";
export { ForwardRef as ReactComponent };